<template>
    <div class="main">
        <ul class="list">
            <li v-for="(item,  index) in list" v-bind:key="index">
                <div class="head">
                    <span>{{item.SHOPPING_TIME}} </span>
                    <span class="right">待付款</span>
                </div>
                <div class="left">
                    <van-checkbox @change='itemchange' v-model="item.checked"></van-checkbox>
                    <img :src="imageURL" alt="">
                </div>
                <div @click="goConfirm(item.RECORD_ID)">
                    <div class="right">
                        <span>{{item.TYPE}}</span>
                        <div class="gray">{{item.NAME}}<span class="num">{{item.PHONE_NUM}}</span></div>
                    </div>
                    <div class="items">
                        <ul>
                            <li>
                                <span>【基础项目】</span><span class="num">x{{item.BASIC}}</span>
                            </li>
                            <li>
                                <span>【新增项目】</span><span class="num">x{{item.ADDITEMS}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="total">
                        <span>小计：</span><b>¥{{item.PRICE}}</b>
                    </div>
                </div>
                <div class="btns">
                    <button @click="tuikuan(item.RECORD_ID)" class="tuikuan">取消订单</button>
                    <button @click="singleSubmit(item)" class="yuyue red">付款</button>
                    <div class="empty"></div>
                </div>
            </li>
        </ul>
        <div class="buy">
            <div class="price">
                <van-checkbox @click.native='change' v-model="allchecked">全选</van-checkbox>
                <span class="c3">合计：</span><b>¥{{totalPrice}}</b>
            </div>
            <button class="btnbuy" @click="submit">去结算</button>
        </div>
        <van-popup v-model="show" position="bottom">
            <div class="pay">
                <div class="head"><i class="iconfont icon-error" @click="show=false;"></i><span>确认付款</span></div>
                <h1>¥{{payPrice}}</h1>
                <!-- <ul> -->
                    <!-- <li> -->
                        <h3>请选择支付方式</h3>
                        <!-- <div @click="selwx" class="items"> -->
                        <div class="items">
                            <img src="../assets/images/wx.png" alt="">
                            <div>
                                <!-- <h1>微信支付</h1> -->
                                <h2>微信支付</h2>
                                <!-- <h2>请仔细核对订单，确认付款后不能撤销</h2> -->
                            </div>
                            <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.wx}"></i>
                        </div>
                        <!-- <div @click="selzfb" class="items">
                                                                <img src="../assets/images/zfb.png" alt="">
                                                                <div>
                                                                    <h1>支付宝</h1>
                                                                    <h2>支付宝11.0及以上版本</h2>
                                                                </div>
                                                                <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.zfb}"></i>
                                                            </div> -->
                    <!-- </li>
                </ul> -->
                <div class="btnPay">
                    <van-button @click='pay' size="small">立即付款</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import api from '@/fetch/api';
    import {
        CellSwipe,
        Dialog,
        Toast
    } from 'vant';
    import {
        mapGetters
    } from 'vuex';
    export default {
        data() {
            return {
                imageURL: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1528431608002&di=00ad850a978b02b196e003a24b19c6c2&imgtype=0&src=http%3A%2F%2Fimg.mp.itc.cn%2Fupload%2F20170413%2F168a43e2babc420d9fe640a2286cb7c6_th.jpeg',
                list: [],
                allchecked: false,
                checkedComboIDs: [],
                num: 0,
                totalPrice: 0,
                show: false,
                wx: true,
                zfb: false,
                payPrice: 0
            }
        },
        created() {
            sessionStorage.removeItem('records');
            this.payBind();
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            payBind() {
                api.goUnpay(this.userInfo.CUSTOMER_ID).then(re => {
                    console.log(re);
                    let list = re.data.UnpayList;
                    if (list.length > 0) {
                        this.list = [];
                        list.forEach(el => {
                            this.list.push({
                                PHONE_NUM: el.PHONE_NUM,
                                PRICE: el.PRICE,
                                SHOPPING_TIME: el.SHOPPING_TIME,
                                ADDITEMS: el.ADDITEMS,
                                RECORD_ID: el.RECORD_ID,
                                TYPE: (el.TYPE == '固定套餐' ? el.COMBO_NAME : el.TYPE),
                                BASIC: el.BASIC,
                                NAME: el.NAME,
                                checked: false
                            })
                        });
                    } else {
                        this.$router.replace('/shoplist')
                    }
                })
            },
            change() {
                this.list.forEach(n => {
                    n.checked = this.allchecked;
                })
            },
            tuikuan(RECORD_ID) {
                Dialog.confirm({
                    title: '取消订单',
                    message: '确定取消订单吗？'
                }).then(() => {
                    Toast.loading({
                        mask: true,
                        message: '处理中...'
                    });
                    setTimeout(() => {
                        api.deleteOrder(RECORD_ID, this.userInfo.CUSTOMER_ID).then(re => {
                            this.payBind();
                            Toast.success('已取消！');
                        });
                    }, 1000);
                }).catch(() => {
                    // on cancel
                });
            },
            selwx() {
                this.wx = !this.wx;
                this.zfb = false;
            },
            selzfb() {
                this.zfb = !this.zfb;
                this.wx = false;
            },
            pay() {
                this.show = false;
                Toast.loading({
                    mask: true,
                    message: '支付中...'
                });
                let params = {
                    orderIds: this.checkedComboIDs,
                    STATUS: 10
                };
                console.log(this.userInfo.CUSTOMER_ID, params);
                // api.changeOrderStatus(this.userInfo.CUSTOMER_ID, params).then(re => {
                //     console.log(re);
                //     if (re.result == true) {
                //         setTimeout(() => {
                //             this.$router.push('/user/paySuccess')
                //         }, 3000);
                //     }
                // });
                let that = this;
                let len = len || 32;
                var chars = '0123456789abcdefghijklmnopqrstuvwxyz';
                let maxPos = chars.length;
                let uuid = '';
                for (var i = 0; i < len; i++) {
                    uuid += chars.charAt(Math.floor(Math.random() * maxPos));
                };
                let trade_state = uuid;
                console.log(this.payPrice, trade_state, this.userInfo.CUSTOMER_ID);
                let order = {};
                if (this.checkedComboIDs.length > 1) {
                    order = this.list.find(v => this.checkedComboIDs.includes(v.RECORD_ID));
                } else {
                    order = this.list.find(v => v.RECORD_ID == this.checkedComboIDs);
                }
                if (order != undefined) {
                    var url = location.search; 
                    var address = ""
                     console.log(url);
                    if (url.indexOf("?") != -1) { 
                        var str = url.substr(7); 
                        var strs = url.split("&state="); 
                        console.log(strs[1]);
                        address = strs[0]
                    }
                    api.pay(this.payPrice, trade_state, this.userInfo.CUSTOMER_ID,address).then(v => {
                        if (v.success == 'ok') {
                            //调用jsAPI
                            if (typeof WeixinJSBridge == undefined) {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                }
                            } else {
                                WeixinJSBridge.invoke(
                                    'getBrandWCPayRequest', {
                                        "appId": v.appid, //公众号名称，由商户传入     
                                        "timeStamp": v.timeStamp, //时间戳，自1970年以来的秒数     
                                        "nonceStr": v.nonceStr, //随机串     
                                        "package": v.package,
                                        "signType": "MD5", //微信签名方式：     
                                        "paySign": v.paySign //微信签名 
                                    },
                                    function(res) {
                                        api.payQuery(trade_state).then(re => {
                                            let ret = re.success;
                                            if (ret != undefined) {
                                                if (ret == 'SUCCESS') {
                                                    api.changeOrderStatus(that.userInfo.CUSTOMER_ID, params).then(re => {
                                                        console.log(re);
                                                        if (re.result == true) {
                                                            setTimeout(() => {
                                                                that.$router.replace({
                                                                    path: '/user/paySuccess',
                                                                    query: {
                                                                        orderID: order.RECORD_ID
                                                                    }
                                                                })
                                                            }, 3000);
                                                        } else {
                                                            Toast.fail('内部程序出错');
                                                        }
                                                    });
                                                } else {
                                                    switch (ret) {
                                                        case 'REFUND':
                                                            Toast('转入退款');
                                                            break;
                                                        case 'NOTPAY':
                                                            Toast('未支付');
                                                            break;
                                                        case 'CLOSED':
                                                            Toast('已关闭');
                                                            break;
                                                        case 'REVOKED':
                                                            Toast('已撤销（刷卡支付）');
                                                            break;
                                                        case 'USERPAYING':
                                                            Toast('用户支付中');
                                                            break;
                                                        case 'PAYERROR':
                                                            Toast.fail('支付失败');
                                                            break;
                                                    }
                                                }
                                            } else {
                                                Toast.fail('支付失败');
                                            }
                                        });
                                    });
                            }
                        } else {
                            Toast.fail('内部程序出错');
                        }
                    });
                }
            },
            singleSubmit(item) {
                this.checkedComboIDs = [];
                if (item.RECORD_ID.length > 0) {
                    this.payPrice = item.PRICE;
                    this.checkedComboIDs.push(item.RECORD_ID);
                }
                this.show = true;
            },
            submit(){
                this.$dialog.confirm({
                    title: '提示',
                    message: '请仔细核对订单，确认付款后不能撤销、不予退款，敬请谅解',
                    cancelButtonText: '不同意',
                    confirmButtonText:'同意'
                }).then(() => {
                    // on confirm
                  this.checkedComboIDs = [];
                  this.payPrice = this.totalPrice;
                  this.list.forEach(n => {
                    if (n.checked) {
                        this.checkedComboIDs.push(n.RECORD_ID);
                    }
                  });
                  //提交订单数据
                  this.show = true;
            
                }).catch(() => {
                    // on cancel
                });
            },
            goYuYue() {
                this.$router.push('/user/singleYuYue')
            },
            itemchange() {
                this.num = 0;
                this.totalPrice = 0;
                this.list.forEach(n => {
                    if (!n.checked) {
                        this.allchecked = false;
                    } else {
                        this.num++;
                        this.totalPrice += parseFloat(n.PRICE);
                    }
                })
            },
            goConfirm(orderID) {
                let item = this.list.find(p => p.RECORD_ID == orderID);
                let selItem = {
                    PHONE_NUM: item.PHONE_NUM,
                    PRICE: item.PRICE,
                    RECORD_ID: item.RECORD_ID,
                    TYPE: item.TYPE,
                    NAME: item.NAME
                };
                console.log(selItem);
                sessionStorage.setItem('records', JSON.stringify(selItem));
                this.$router.push('/user/confimOrder/' + orderID);
            }
        },
    }
</script>

<style scoped lang='less'>
    .van-checkbox {
        display: inline;
    }
    .buy {
        font-family: "Microsoft YaHei" !important;
        padding-left: 1em;
        .btnbuy {
            padding: 0 1.2em;
        }
        .price {
            span {
                display: inline;
                font-size: 1rem !important;
                margin-left: 2em;
            }
        }
    }
    .pay {
        .head {
            padding: 0.5em;
            position: relative;
            text-align: center;
            border-bottom: 1px solid rgb(226, 226, 226);
            .iconfont {
                position: absolute;
                left: 0.3em;
                top: 0.4em;
            }
        }
        .btnPay {
            text-align: center;
        }
        button {
            background: #99C51D;
            margin: 1em auto;
            color: #fff;
            font-weight: bold;
            font-size: 1rem;
            width: 95%;
            border-radius: 10px;
            height: 3em;
        }
        h1 {
            text-align: center;
            font-weight: normal;
            padding: 1em 0 0.3em 0;
        }
        ul {
            li {
                font-size: 0.8rem;
                color: #333;
                padding: 0.5em 1em;
            }
        }
        .items {
            border-bottom: 1px solid rgb(226, 226, 226);
            position: relative;
            margin-bottom: 0.4em;
            img {
                position: absolute;
                left: 1em;
                top: 0;
                width: 2.5em;
            }
            >div {
                margin-left: 5em;
                h1 {
                    color: #333;
                }
                h2 {
                    color: #999;
                }
                h1,
                h2 {
                    padding: 0.6em 0;
                    margin: 0;
                    text-align: left;
                    font-size: 1.0em;
                    background: #fff;
                    line-height: 1.5em;
                }
            }
            i {
                position: absolute;
                right: 1em;
                top: 0.4em;
                color: #999;
            }
            .active {
                color: #99C51D;
            }
        }
    }
    .gray {
        color: #BCBCBC;
    }
    .num {
        position: absolute;
        right: 1em;
    }
    .list {
        font-family: "Microsoft YaHei" !important;
        padding-bottom: 3em;
        .head {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            box-sizing: border-box;
            border-width: 4px;
            border-style: solid;
            border-color: #43852E;
            border-top: 0px; // border-left: 0px;
            border-right: 0px;
            border-bottom: 0px;
            padding-left: 1em;
            font-size: 0.8rem;
            height: 2.5em;
            line-height: 2.5em;
            border-bottom: 1px solid #eee;
            .right {
                position: absolute;
                right: 1em;
                top: 0;
                margin-top: 0;
                font-size: 0.8rem;
                color: #FF7C3E;
            }
        }
        .btns {
            position: absolute;
            bottom: 0;
            clear: both;
            text-align: right;
            font-size: 0.8rem;
            padding-top: 0.5em;
            width: 100%;
            left: 0;
            border-top: 1px solid #eee;
            button {
                border-radius: 10px;
                border: 1px solid #ccc;
                color: #666;
                width: 5rem;
                text-align: center;
                line-height: 1.8em;
                margin-bottom: 0.4em;
                background: #fff;
                margin-left: 1em;
            }
            .blue {
                color: #99C51D;
                border-color: #99C51D;
            }
            .red {
                color: #ff681d;
                border-color: #ff681d;
            }
            .empty {
                display: inline-block;
                width: 1em;
            }
        }
        .right {
            margin-top: 0.5em;
            font-size: 1rem;
            >span {
                display: block;
                line-height: 2em;
            }
        }
        .total {
            text-align: right;
            font-size: 0.8rem;
            margin-top: 0.5em;
            b {
                font-size: 1rem;
                color: #FF7C3E;
            }
        }
        .items {
            margin-top: 0.8em;
            li {
                position: relative;
                font-size: 0.8rem;
                .num {
                    right: 0;
                }
            }
        }
        >li {
            height: 11em;
            position: relative;
            padding: 2em 1em 0.2em 10em;
            border-bottom: 5px solid #eee;
            overflow: hidden; // margin-bottom: 1em;
        }
        .left {
            position: absolute;
            left: 1em;
            top: 1em;
            .van-checkbox {
                position: absolute;
                top: 5.5em;
                left: 0;
            }
            img {
                width: 6em;
                height: 6em;
                position: absolute;
                left: 2em;
                top: 2em;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/orderPay.vue